module.exports = {"533122101":"遮岛镇","533122102":"芒东镇","533122103":"勐养镇","533122201":"平山乡","533122202":"小厂乡","533122203":"大厂乡","533122204":"九保阿昌族乡","533122205":"曩宋阿昌族乡","533122206":"河西乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533122.json
// module id = 2662
// module chunks = 0